export default import.meta.ROLLDOWN_FILE_URL_AsHNVVn_Y92mmWEtoBC9VA